import { createSlice } from '@reduxjs/toolkit';
import {getSecurityMeasuresAsync} from './Actions';

export interface SecurityMeasuresValues {
  value: string; 
  label: string;
  subclausulas?: Array<SecurityMeasuresValues>
}

export interface SecurityMeasuresState {
  status: 'idle' | 'loading' | 'failed';
  securityMeasures: Array<SecurityMeasuresValues>;
  errorMessage: string | undefined;
}

const initialState: SecurityMeasuresState = {
  status: 'idle',
  securityMeasures: [],
  errorMessage: '',
};


export const securityMeasuresSlice = createSlice({
  name: 'SecurityMeasures',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSecurityMeasuresAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getSecurityMeasuresAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.securityMeasures = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getSecurityMeasuresAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.securityMeasures = action.payload;
        state.errorMessage = ''
      })
  },
});

export default securityMeasuresSlice.reducer;
